<div class="container-fluid spacer-top-navigation">
  <div class="container tile">
    <div class="row mb-4">
      <div class="col-11">
        <h1 id="description">
          {{ 'tradable-products.headline' | transloco }}
        </h1>
      </div>
      <div class="col-1 d-flex justify-content-end">
        <div class="circle">
          <a href="/assets/searchdata/downloadable-instruments.csv" target="_blank" rel="noopener noreferrer">
            <svg class="icon icon-16">
              <use xlink:href="/assets/img/svgs/svgset.svg#download-redesign-22" />
            </svg>
          </a>
        </div>
      </div>
    </div>
    <div class="row">
      @if (instrumentsLoaded) {
        <div class="col-12">
          @if (hasError) {
            <div class="row">
              <div class="col-12">
                {{ 'tradable-products.error' | transloco }}
              </div>
            </div>
          } @else {
            <div class="row mb-4">
              <div class="asset-search col-12">
                <div class="input-group-material">
                  <input
                    type="text"
                    spellcheck="false"
                    [(ngModel)]="query"
                    (ngModelChange)="query$.next($event)"
                    [placeholder]="'tradable-products.search-label' | transloco"
                  />
                  <div class="input-group-material-icon text-color-basic mirror">
                    <svg class="icon">
                      <use xlink:href="/assets/img/svgs/svgset.svg#search" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-sm-12 col-md-8">
                <div class="row justify-content-between align-items-end">
                  @for (tag of tags; track tag.name; let i = $index) {
                    <div class="col-6 col-md-4 col-xl-2">
                      @if (i === 0) {
                        <span class="font-size-smaller2">
                          <strong>
                            {{ 'tradable-products.securities.title' | transloco }}
                          </strong>
                        </span>
                        <br />
                      }
                      <button
                        type="button"
                        data-bs-toggle="button"
                        class="tradable-products-toggle"
                        [class.active]="tag.isActive"
                        [attr.aria-pressed]="tag.isActive"
                        (click)="toggleFilterTag(tag)"
                        data-zid="filter-button"
                      >
                        <strong>{{ 'tradable-products.tags.' + tag.name | transloco }}</strong> <br />
                        @if (!query && !(shouldDisplaySavingsPlans || shouldDisplayFractional)) {
                          ({{ tag.count | number }})
                        }
                      </button>
                    </div>
                  }
                </div>
              </div>
              <div class="col-sm-12 col-md-4">
                <div class="row align-items-end tradable-products border-left">
                  <div class="col col-lg-12 col-xl-6">
                    <span class="font-size-smaller2">
                      <strong>
                        {{ 'tradable-products.securities.filter' | transloco }}
                      </strong>
                    </span>
                    <br />
                    <button
                      type="button"
                      data-bs-toggle="button"
                      class="tradable-products-toggle"
                      [class.active]="shouldDisplaySavingsPlans"
                      [attr.aria-pressed]="shouldDisplaySavingsPlans"
                      (click)="toggleSavingsPlanTag()"
                      data-zid="filter-button-savingsplan"
                    >
                      <strong>{{ 'tradable-products.savings-plan' | transloco }}</strong>
                    </button>
                  </div>
                  <div class="col col-lg-12 col-xl-6">
                    <button
                      type="button"
                      data-bs-toggle="button"
                      class="tradable-products-toggle"
                      [class.active]="shouldDisplayFractional"
                      [attr.aria-pressed]="shouldDisplayFractional"
                      (click)="toggleSavingsFractionalTag()"
                      data-zid="filter-button-fractional"
                    >
                      <strong>{{ 'tradable-products.fractional' | transloco }}</strong>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <table class="table-depot" aria-describedby="description">
              <thead>
                <tr>
                  <th>
                    {{ 'tradable-products.name' | transloco }}
                  </th>
                  <th>
                    {{ 'tradable-products.isin' | transloco }}
                  </th>
                  <th>
                    {{ 'tradable-products.wkn' | transloco }}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for (item of results; track item.isin) {
                  @if (item.longName) {
                    <tr>
                      <td class="font-medium">
                        <web-components-instrument-details-link class="font-medium" [isin]="item.isin">
                          {{ item.longName }}
                        </web-components-instrument-details-link>
                      </td>
                      <td>
                        <div class="d-flex justify-content-end">
                          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                            {{ 'tradable-products.isin' | transloco }}
                          </div>
                          <div>{{ item.type === instrumentType.Crypto ? item.shortName : item.isin }}</div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-end">
                          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                            {{ 'tradable-products.wkn' | transloco }}
                          </div>
                          <div>
                            @if (item.wkn) {
                              {{ item.wkn ?? '-' }}
                            } @else {
                              &mdash;
                            }
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-end">
                          @if (item.sparplan) {
                            <div
                              class="trade savings-plan cursor-pointer"
                              [title]="'tradable-products.save' | transloco"
                              [routerLink]="[commonRoutes.postlogin.add_savings_plan, item.isin]"
                            >
                              <svg class="icon icon-24">
                                <use xlink:href="/assets/img/svgs/svgset.svg#pig" />
                              </svg>
                            </div>
                          }
                          <div
                            class="trade buy cursor-pointer"
                            [title]="'tradable-products.buy' | transloco"
                            [routerLink]="commonRoutes.postlogin.buyAndSell"
                            [queryParams]="{ isin: item.isin, direction: 'buy' }"
                          >
                            K
                          </div>
                          <div
                            class="trade sell cursor-pointer"
                            [title]="'tradable-products.sell' | transloco"
                            [routerLink]="commonRoutes.postlogin.buyAndSell"
                            [queryParams]="{ isin: item.isin, direction: 'sell' }"
                          >
                            V
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                }
                @if (!results?.length) {
                  <tr>
                    <td colspan="4">
                      {{ 'tradable-products.no-results' | transloco }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            <div class="d-flex flex-grow justify-content-end mb-2 mt-2">
              <a [class.hidden]="hits < pageSize * currentPage" (click)="showMore()" class="cursor-pointer link-secondary">
                {{ 'tradable-products.more' | transloco }} <span class="sorter-after-flat sorter-after-flat--down"></span>
              </a>
            </div>
          }
        </div>
      } @else {
        <div class="col-12 text-color-primary">
          <p>
            {{ 'tradable-products.loading' | transloco }}
          </p>
        </div>
      }
      <ng-template #loading>
        <div class="col-12 text-color-primary">
          <p>
            {{ 'tradable-products.loading' | transloco }}
          </p>
        </div>
      </ng-template>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <p class="font-size-smaller2">
          {{ 'tradable-products.footer' | transloco }}
        </p>
      </div>
    </div>
  </div>
</div>
